import {Component, Inject, OnDestroy} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Subscription} from 'rxjs';

import {FundOrderTypesEnum} from '@spa/api';
import {DialogActionsEnum, DialogComponent, DialogConfigInterface} from 'src/app/shared/components/dialog';
import {ProductDialogType} from "../../../services";

@Component({
  selector: 'app-create-order-dialog',
  templateUrl: './create-order-dialog.component.html',
  styleUrls: ['./create-order-dialog.component.scss'],
})
export class CreateOrderDialogComponent
  extends DialogComponent<CreateOrderDialogComponent>
  implements OnDestroy {
  public imageSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      config: DialogConfigInterface,
      productSymbol: string,
      orderType: FundOrderTypesEnum
    },
    public dialogRef: MatDialogRef<CreateOrderDialogComponent>) {
    super(dialogRef);
  }

  ngOnDestroy(): void {
    if (this.imageSubscription) {
      this.imageSubscription.unsubscribe();
    }
  }

  onFormSubmit(action?: number): void {
    if (action === DialogActionsEnum.Decline) {
      this.dialogRef.close();
    }
  }

  completed(success: boolean): void {
    this.dialogRef.close(success);
  }
}
